var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocalizacion({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.636,
    height: 23.201,
    viewBox: "0 0 17.636 23.201",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#173c6d",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: "2px",
    d: "M7.655 21.14l-.038-.04C6.347 19.569 0 11.707 0 7.816a7.817 7.817 0 0 1 13.344-5.527 7.766 7.766 0 0 1 2.292 5.527c0 3.849-6.209 11.584-7.574 13.235l-.043.05a.252.252 0 0 1-.364.036zm.164-9.717a3.307 3.307 0 0 0 .243-6.605c-.079 0-.16-.01-.243-.01a3.307 3.307 0 1 0 0 6.614z",
    transform: "translate(1.001 1) translate(-.001)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocalizacion);
export default __webpack_public_path__ + "static/media/localizacion.554a87afe7247e61732fd5fd0b9c3f11.svg";
export { ForwardRef as ReactComponent };